import { render, staticRenderFns } from "./MessageMenuDropDown.vue?vue&type=template&id=45b7cfa1&scoped=true&"
import script from "./MessageMenuDropDown.vue?vue&type=script&lang=ts&"
export * from "./MessageMenuDropDown.vue?vue&type=script&lang=ts&"
import style0 from "./MessageMenuDropDown.vue?vue&type=style&index=0&id=45b7cfa1&lang=less&scoped=true&"
import style1 from "./MessageMenuDropDown.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45b7cfa1",
  null
  
)

export default component.exports